import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      id="footer" 
      className="py-6 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 transition-colors duration-300"
    >
      <div className="container mx-auto text-center px-4">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          {currentYear} &copy; Designed and Developed by{" "}
          <Link 
            to="https://voipadda.com" 
            className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-semibold transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            CALL Adda
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;